module.exports = __webpack_public_path__ + "static/media/03.e1b64d69.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTwo/expos/03.png
// module id = 174
// module chunks = 0